module.exports = __webpack_public_path__ + "static/media/microphone-off-off.5bb0f9df.svg";